import * as React from 'react';
import Fade from '@mui/material/Fade';
import Popper from '@mui/material/Popper';
import Button from '@mui/material/Button';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import Divider from '@mui/material/Divider';
import { Avatar, Paper } from '@mui/material';
import SvgIcon from '@mui/material/SvgIcon';
import { ReactComponent as StatsLogo } from "../image/finance.svg";

export default function TutorialDialog({ open = false, target = null, plac = null, steps = [], onFinishClick = null}) {
  const [popperOpen, setPopperOpen] = React.useState(open);
  const [anchorEl, setAnchorEl] = React.useState(target);
  const [placement, setPlacement] = React.useState(plac);

  React.useEffect(() => {
    setPopperOpen(open);
    setAnchorEl(target);
    setPlacement(plac);
  }
  , [open]);

  if (anchorEl === null) {
    return null
  }

  return (
    <Popper
        // Note: The following zIndex style is specifically for documentation purposes and may not be necessary in your application.
        sx={{ zIndex: 1200 }}
        open={popperOpen}
        anchorEl={anchorEl}
        placement={placement}
        transition
        elevation={2}
      >
        {({ TransitionProps }) => (
          <Fade {...TransitionProps} timeout={350}>
            <Paper>
                <List sx={styles.divider} style={{ backgroundColor: "#3a5081"}} >
                    {steps.map((s, index) => 
                        <>
                            <ListItem style={{ backgroundColor: "#3a5081"}}>
                                <Avatar sx={{ bgcolor: '#EB5B2D', marginRight: 2 }}>{index + 1}</Avatar>
                                <ListItemText primary={s} style={{ color: 'white' }} />
                                {s.indexOf('Statistiche') > 0 && 
                                  <SvgIcon style={{ color: 'white'}}><StatsLogo /></SvgIcon>
                                }
                            </ListItem>
                            <Divider />
                        </>
                    )}
                </List>

                <div style={{ display: 'flex', justifyContent: 'center', backgroundColor: "#3a5081"}}>
                    <Button 
                        variant="contained" 
                        color="success" 
                        onClick={(event) => {
                            onFinishClick()
                        }} 
                        style={{ margin: 20, backgroundColor: "#EB5B2D"}}>
                        Ho finito
                    </Button>
                </div>
            </Paper>
          </Fade>
        )}
      </Popper>
  );
}

const styles = {
    divider: {
        p: 0,
        width: '100%',
        maxWidth: 400,
        backgroundColor: 'background.paper',
    }
};